<ntap-view-window
  #childWindow
  target="generator_urbroj_dialog"
  [contentTemplate]="viewWindowContent"
>
  <ng-template #viewWindowContent let-defaultTemplate>
    <ng-container ntapDynamicFormProvider>
      <ntap-prime-popupview appendTo="body" [modal]="true">
        <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
      </ntap-prime-popupview>
    </ng-container>
  </ng-template>
</ntap-view-window>
<ng-container *ngIf="action$ | async as action">
  <p-button
    ntapDebounceClick
    [icon]="'pi ' + (action.icon ? 'pi-' + action.icon : 'pi-hidden')"
    [ngClass]="action.name + ' hide-label-responsive'"
    [label]="action.description"
    (onClick)="executeAction($event)"
    [disabled]="(isDisabled$ | async) ?? true"
  ></p-button>
</ng-container>
